import { render, staticRenderFns } from "./OfferTemplatePartText.vue?vue&type=template&id=484e5c3d&"
import script from "./OfferTemplatePartText.vue?vue&type=script&lang=js&"
export * from "./OfferTemplatePartText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('484e5c3d')) {
      api.createRecord('484e5c3d', component.options)
    } else {
      api.reload('484e5c3d', component.options)
    }
    module.hot.accept("./OfferTemplatePartText.vue?vue&type=template&id=484e5c3d&", function () {
      api.rerender('484e5c3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/offer-template/OfferTemplatePartText.vue"
export default component.exports